import React, { useContext } from 'react';
import { CustomThemeContext } from './themes/CustomThemeProvider';
import './App.css';
import { Helmet } from 'react-helmet';
import HeaderAppBar from './components/Header/HeaderComponent';
import WallpapersComponent from './components/AllWallpapers/AllWallpapersComponent';
import BottomNavigationBar from './components/BottomNavigation/BottomNavigationComponent';
import InfoPage from './components/Info/InfoComponent';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import SearchBar from './components/Header/SearchBarComponent';
import FullscreenView from './components/AllWallpapers/FullScreenViewComponent';
import NotFound from './components/NotFound/NotFoundPage';
import { backgroundDark, backgroundLight } from './AppConfig';



function App() {

const { currentTheme } = useContext(CustomThemeContext)
const isDark = Boolean(currentTheme === 'dark')

  return (
    <div>
      <Helmet>
        <meta name='theme-color' content={ isDark ? backgroundDark : backgroundLight } />
      </Helmet>
        <Switch>
        <Route exact path='/' 
        render={() => 
        <div>
          <HeaderAppBar />
          <WallpapersComponent />
        </div> 
        } />
        <Route path='/#/:name' component={FullscreenView}/>
        <Route exact path='/search' 
        render={() => 
        <div style={{ paddingTop: '56px' }}>
            <SearchBar />
            <WallpapersComponent />
        </div> 
        } />
        <Route exact path='/info' component={InfoPage}/>
        <Route path="/404" component={NotFound}/>
        <Redirect to="404" />
        </Switch>
        <BottomNavigationBar />
      </div>
  );
}

export default withRouter(App);
